// Code from https://usehooks.com/useWindowSize/
import { useState, useEffect } from "react"
import debounce from "lodash.debounce"

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    const debouncedResizeHandler = debounce(handleResize, 500)

    window.addEventListener("resize", debouncedResizeHandler)
    handleResize()

    return () => window.removeEventListener("resize", debouncedResizeHandler)
  }, [])

  return windowSize
}

export default useWindowSize
